import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { useTemplatesContext } from "../../context/templatesContext";

// Syncs the URL `search` param into the reducer searchText. The templates list
// query refetches automatically when its key (filters) changes, so this no
// longer needs to trigger a manual fetch.
export const useSearchParamsToReducer = () => {
	const [searchParams, setSearchParams] = useSearchParams();

	const {
		state: { searchText },
		actions,
	} = useTemplatesContext();

	useEffect(() => {
		let shouldUpdate = false;

		if (searchParams.has("search")) {
			const search = searchParams.get("search");
			if (search === "") {
				searchParams.delete("search");
				shouldUpdate = true;
			} else if (search !== searchText) {
				actions.setSearchText(search);
			}
		} else if (searchText !== "") {
			actions.setSearchText("");
		}

		if (shouldUpdate) {
			setSearchParams(searchParams, { replace: true });
		}
	}, [searchParams]);
};
